import { render, staticRenderFns } from "./PnOnboardingPanelList.vue?vue&type=template&id=657c3cb8&scoped=true"
import script from "./PnOnboardingPanelList.vue?vue&type=script&lang=js"
export * from "./PnOnboardingPanelList.vue?vue&type=script&lang=js"
import style0 from "./PnOnboardingPanelList.vue?vue&type=style&index=0&id=657c3cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657c3cb8",
  null
  
)

export default component.exports